export * from './schema'
export * from './icons'
export * from './mcp'
export * from './preset'
export * from './registry'
export * from './utils'
export * from './futuristicui'
export * from './colors'
export * from './default-theme'
export * from './flatten-color-palette'
export * from './lib'
export * from './plugin'

export function getFrameworkVersion() {
    return '3.1.0'
}

export function getCoreStylesPath() {
    return './dist/bismillah.css'
}

export function getUltraStylesPath() {
    return './src/components/high-quality-ultra.css'
}
